module.exports = "/_next/static/images/2cfe9d49b984a6083c81dfa015896172-cards-and-device@3x.jpg";